module.exports = "<p>\n  demand-survey-draft works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/demand-survey-draft/demand-survey-draft.component.html
// module id = ./src/app/allocation/demand-survey-draft/demand-survey-draft.component.html
// module chunks = main